import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';

import { type EditionAwarenessContextType } from './edition-awareness-context';

export function isEligibleForJsmStorageOverLimit(context: EditionAwarenessContextType): boolean {
	const {
		storageUsageInGB,
		storageLimitInGB,
		storageIsUnlimited,
		product,
		edition,
		canUpgrade,
		canDirectBuyUpgrade,
		userRoles,
	} = context;

	if (!storageUsageInGB || !storageLimitInGB) {
		return false;
	}

	const userIsJiraAdmin = userRoles?.includes('JIRA_ADMIN') ?? false;

	const isStorageLimitsExperimentEnabled =
		edition === 'free' &&
		(product === 'jira-service-management' || product === 'jira-customer-service') &&
		FeatureGates.getExperimentValue<boolean>(
			'jsmgrowth-267_enforce_storage_limits_servco_free',
			'isEnabled',
			false,
		);

	return (
		product === 'jira-service-management' &&
		userIsJiraAdmin &&
		edition === 'free' &&
		!!(canUpgrade || canDirectBuyUpgrade) &&
		!storageIsUnlimited &&
		storageUsageInGB >= storageLimitInGB &&
		isStorageLimitsExperimentEnabled
	);
}
